export default {
  title: (
    <>
      Invita a tus amigos y <br /> coleccionad recompensas juntos
    </>
  ),
  textButton: 'Más información',
};
